var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLink)?_c('a',{key:_vm.action.uri,staticClass:"action-button button",style:({
    background: _vm.widgetColor,
    borderColor: _vm.widgetColor,
    color: _vm.textColor,
  }),attrs:{"href":_vm.action.uri,"target":"_blank","rel":"noopener nofollow noreferrer"}},[_vm._v("\n  "+_vm._s(_vm.action.text)+"\n")]):_c('button',{key:_vm.action.payload,staticClass:"action-button button",style:({ borderColor: _vm.widgetColor, color: _vm.widgetColor }),on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.action.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }